import { renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-25aed5a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ub ub-pb ub-ac fw" }
const _hoisted_2 = { class: "ub ub-ae" }
const _hoisted_3 = { class: "ub ub-ac title" }
const _hoisted_4 = { class: "ub ub-ac sub-title" }

export function render(_ctx, _cache) {
  const _component_close_outlined = _resolveComponent("close-outlined")
  const _component_a_button = _resolveComponent("a-button")
  const _component_a_space = _resolveComponent("a-space")

  return (_openBlock(), _createElementBlock("div", {
    class: "ub ub-ver dialog-div",
    style: _normalizeStyle({width:_ctx.dialogWidth>0?_ctx.dialogWidth+'px':'90%'})
  }, [
    (_ctx.hasHeaderSlot)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "dialog-div__hd",
          style: _normalizeStyle({'min-height':_ctx.dialogHeaderHeight+'px'})
        }, [
          _renderSlot(_ctx.$slots, "header", {}, undefined, true)
        ], 4))
      : _createCommentVNode("", true),
    (!_ctx.hasHeaderSlot && _ctx.title)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "ub fw dialog-div__hd",
          style: _normalizeStyle({'min-height':_ctx.dialogHeaderHeight+'px'})
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.title), 1),
              _createElementVNode("small", _hoisted_4, _toDisplayString(_ctx.subTitle), 1)
            ])
          ])
        ], 4))
      : _createCommentVNode("", true),
    _createVNode(_component_close_outlined, {
      onClick: _ctx.close,
      style: _normalizeStyle([{fontSize:'16px',cursor:'pointer'}, {"position":"absolute","right":"24px","top":"17px","z-index":"999"}])
    }, null, 8, ["onClick"]),
    (_ctx.hasBodySlot)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "dialog-div__bd",
          style: _normalizeStyle({'max-height':_ctx.dialogBodyHeight+'px'})
        }, [
          _renderSlot(_ctx.$slots, "body", {}, undefined, true)
        ], 4))
      : (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: "dialog-div__bd",
          style: _normalizeStyle({'max-height':_ctx.dialogBodyHeight+'px'})
        }, [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ], 4)),
    (_ctx.showFooter)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
          (_ctx.hasFooterSlot)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "dialog-div__ft",
                style: _normalizeStyle({height:_ctx.dialogFooterHeight+'px'})
              }, [
                _renderSlot(_ctx.$slots, "footer", {}, undefined, true)
              ], 4))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "ub ub-pe fw dialog-div__ft",
                style: _normalizeStyle({height:_ctx.dialogFooterHeight+'px'})
              }, [
                _createVNode(_component_a_space, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, { onClick: _ctx.close }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.cancelText), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_a_button, {
                      type: "primary",
                      onClick: _ctx.ok,
                      loading: _ctx.loading
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.confirmText), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick", "loading"])
                  ]),
                  _: 1
                })
              ], 4))
        ], 64))
      : _createCommentVNode("", true)
  ], 4))
}